import { Icon } from '@nearst/ui';
import styles from './OrderStatus.module.scss';

const statusText = {
	paid: 'Pending',
	confirmed: 'Confirmed',
	cancelled: 'Cancelled',
	completed: 'Completed',
	refunded: 'Cancelled',
	refund_failed: 'Cancelled',
	reserved: 'Pending',
	partially_refunded: 'Partially refunded',
	partially_completed: 'Partially completed'
};

const statusIcon = {
	paid: 'panorama_fish_eye',
	confirmed: 'timelapse',
	cancelled: 'cancel',
	completed: 'check_circle',
	refunded: 'cancel',
	refund_failed: 'cancel',
	reserved: 'panorama_fish_eye',
	partially_refunded: 'remove_circle_outline',
	partially_completed: 'check_circle'
};

const textStyle = {
	Pending: 'pending',
	Confirmed: 'confirmed',
	Cancelled: 'cancelled',
	Completed: 'completed'
};

const humanise = (status) =>
	String(status)
		.replaceAll('_', ' ')
		.replace(/^./, (character) => character.toUpperCase());

const OrderStatus = ({ orderStatus }) => {
	const text = statusText[orderStatus] || humanise(orderStatus);
	const icon = statusIcon[orderStatus] || 'panorama_fish_eye';
	const colour = styles[textStyle[text] || 'neutral'];

	return (
		<div className={`${colour} ${styles.orderStatus}`}>
			<Icon className={`${colour} ${styles.orderStatusIcon}`}>{icon}</Icon> <b>{text}</b>
		</div>
	);
};

export default OrderStatus;
